export const ASSIGNEEPICKER_ANALYTICS = {
  VIEW: 'prodex.member_picker.view',
  GROUP_FILTER_APPLY: 'prodex.member_picker.filter.apply',
  ITEM_SELECT: 'prodex.member_picker.items.select',
  INCLUDE_GROUP_MEMBERS_CHANGED:
    'prodex.member_picker.include_group_members.checked_changed',
} as const;
